export default __webpack_public_path__ + "static/media/mars_symbol.29286857.png";